const emojiData = [
  { file: 'emoji_00.png', id: 'emoticon_emoji_0', tag: '[大笑]' },
  { file: 'emoji_01.png', id: 'emoticon_emoji_01', tag: '[开心]' },
  { file: 'emoji_02.png', id: 'emoticon_emoji_02', tag: '[色]' },
  { file: 'emoji_03.png', id: 'emoticon_emoji_03', tag: '[酷]' },
  { file: 'emoji_04.png', id: 'emoticon_emoji_04', tag: '[奸笑]' },
  { file: 'emoji_05.png', id: 'emoticon_emoji_05', tag: '[亲]' },
  { file: 'emoji_06.png', id: 'emoticon_emoji_06', tag: '[伸舌头]' },
  { file: 'emoji_07.png', id: 'emoticon_emoji_07', tag: '[眯眼]' },
  { file: 'emoji_08.png', id: 'emoticon_emoji_08', tag: '[可爱]' },
  { file: 'emoji_09.png', id: 'emoticon_emoji_09', tag: '[鬼脸]' },
  { file: 'emoji_10.png', id: 'emoticon_emoji_10', tag: '[偷笑]' },
  { file: 'emoji_11.png', id: 'emoticon_emoji_11', tag: '[喜悦]' },
  { file: 'emoji_12.png', id: 'emoticon_emoji_12', tag: '[狂喜]' },
  { file: 'emoji_13.png', id: 'emoticon_emoji_13', tag: '[惊讶]' },
  { file: 'emoji_14.png', id: 'emoticon_emoji_14', tag: '[流泪]' },
  { file: 'emoji_15.png', id: 'emoticon_emoji_15', tag: '[流汗]' },
  { file: 'emoji_16.png', id: 'emoticon_emoji_16', tag: '[天使]' },
  { file: 'emoji_17.png', id: 'emoticon_emoji_17', tag: '[笑哭]' },
  { file: 'emoji_18.png', id: 'emoticon_emoji_18', tag: '[尴尬]' },
  { file: 'emoji_19.png', id: 'emoticon_emoji_19', tag: '[惊恐]' },
  { file: 'emoji_20.png', id: 'emoticon_emoji_20', tag: '[大哭]' },
  { file: 'emoji_21.png', id: 'emoticon_emoji_21', tag: '[烦躁]' },
  { file: 'emoji_22.png', id: 'emoticon_emoji_22', tag: '[恐怖]' },
  { file: 'emoji_23.png', id: 'emoticon_emoji_23', tag: '[两眼冒星]' },
  { file: 'emoji_24.png', id: 'emoticon_emoji_24', tag: '[害羞]' },
  { file: 'emoji_25.png', id: 'emoticon_emoji_25', tag: '[睡着]' },
  { file: 'emoji_26.png', id: 'emoticon_emoji_26', tag: '[冒星]' },
  { file: 'emoji_27.png', id: 'emoticon_emoji_27', tag: '[口罩]' },
  { file: 'emoji_28.png', id: 'emoticon_emoji_28', tag: '[OK]' },
  { file: 'emoji_29.png', id: 'emoticon_emoji_29', tag: '[好吧]' },
  { file: 'emoji_30.png', id: 'emoticon_emoji_30', tag: '[鄙视]' },
  { file: 'emoji_31.png', id: 'emoticon_emoji_31', tag: '[难受]' },
  { file: 'emoji_32.png', id: 'emoticon_emoji_32', tag: '[不屑]' },
  { file: 'emoji_33.png', id: 'emoticon_emoji_33', tag: '[不舒服]' },
  { file: 'emoji_34.png', id: 'emoticon_emoji_34', tag: '[愤怒]' },
  { file: 'emoji_35.png', id: 'emoticon_emoji_35', tag: '[鬼怪]' },
  { file: 'emoji_36.png', id: 'emoticon_emoji_36', tag: '[发怒]' },
  { file: 'emoji_37.png', id: 'emoticon_emoji_37', tag: '[生气]' },
  { file: 'emoji_38.png', id: 'emoticon_emoji_38', tag: '[不高兴]' },
  { file: 'emoji_39.png', id: 'emoticon_emoji_39', tag: '[皱眉]' },
  { file: 'emoji_40.png', id: 'emoticon_emoji_40', tag: '[心碎]' },
  { file: 'emoji_41.png', id: 'emoticon_emoji_41', tag: '[心动]' },
  { file: 'emoji_42.png', id: 'emoticon_emoji_42', tag: '[好的]' },
  { file: 'emoji_43.png', id: 'emoticon_emoji_43', tag: '[低级]' },
  { file: 'emoji_44.png', id: 'emoticon_emoji_44', tag: '[赞]' },
  { file: 'emoji_45.png', id: 'emoticon_emoji_45', tag: '[鼓掌]' },
  { file: 'emoji_46.png', id: 'emoticon_emoji_46', tag: '[给力]' },
  { file: 'emoji_47.png', id: 'emoticon_emoji_47', tag: '[打你]' },
  { file: 'emoji_48.png', id: 'emoticon_emoji_48', tag: '[阿弥陀佛]' },
  { file: 'emoji_49.png', id: 'emoticon_emoji_49', tag: '[拜拜]' },
  { file: 'emoji_50.png', id: 'emoticon_emoji_50', tag: '[第一]' },
  { file: 'emoji_51.png', id: 'emoticon_emoji_51', tag: '[拳头]' },
  { file: 'emoji_52.png', id: 'emoticon_emoji_52', tag: '[手掌]' },
  { file: 'emoji_53.png', id: 'emoticon_emoji_53', tag: '[剪刀]' },
  { file: 'emoji_54.png', id: 'emoticon_emoji_54', tag: '[招手]' },
  { file: 'emoji_55.png', id: 'emoticon_emoji_55', tag: '[不要]' },
  { file: 'emoji_56.png', id: 'emoticon_emoji_56', tag: '[举着]' },
  { file: 'emoji_57.png', id: 'emoticon_emoji_57', tag: '[思考]' },
  { file: 'emoji_58.png', id: 'emoticon_emoji_58', tag: '[猪头]' },
  { file: 'emoji_59.png', id: 'emoticon_emoji_59', tag: '[不听]' },
  { file: 'emoji_60.png', id: 'emoticon_emoji_60', tag: '[不看]' },
  { file: 'emoji_61.png', id: 'emoticon_emoji_61', tag: '[不说]' },
  { file: 'emoji_62.png', id: 'emoticon_emoji_62', tag: '[猴子]' },
  { file: 'emoji_63.png', id: 'emoticon_emoji_63', tag: '[炸弹]' },
  { file: 'emoji_64.png', id: 'emoticon_emoji_64', tag: '[睡觉]' },
  { file: 'emoji_65.png', id: 'emoticon_emoji_65', tag: '[筋斗云]' },
  { file: 'emoji_66.png', id: 'emoticon_emoji_66', tag: '[火箭]' },
  { file: 'emoji_67.png', id: 'emoticon_emoji_67', tag: '[救护车]' },
  { file: 'emoji_68.png', id: 'emoticon_emoji_68', tag: '[便便]' }
];

export const linkTransform = (data) => {
  let text = data;
  const stack = [];
  let pointer = 0;
  let tag = '';
  let end = '';

  // eslint-disable-next-line no-unreachable-loop
  while (true) {
    const index = text.indexOf('@');

    if (!text.length) {
      break;
    }

    if (index === -1) {
      stack.push(text);
      break;
    } else if (index > 0) {
      stack.push(text.substring(0, index));
      text = text.substring(index, text.length);
    }

    pointer = 0;

    end = text.substring(pointer, text.length).indexOf(' ');

    if (end === -1 && text.length) {
      stack.push(`<span class="mention-link">${text}</span>`);
      break;
    }

    tag = text.substring(pointer, end + 1);

    text = text.substring(end + 1, text.length);

    if (tag.includes('@')) {
      stack.push(`<span class="mention-link">${tag}</span>`);
    } else {
      stack.push(tag);
    }
  }

  return stack.join('');
};

export const emojiTransform = (data) => {
  let text = data;
  const stack = [];
  let pointer = 0;
  let tag = '';
  let end = '';

  // eslint-disable-next-line no-unreachable-loop
  while (true) {
    const index = text.indexOf('[');

    if (!text.length) {
      break;
    }

    if (index === -1) {
      stack.push(text);
      break;
    } else if (index > 0) {
      stack.push(text.substr(0, index));
    }

    pointer = index;

    end = text.indexOf(']');
    tag = text.substring(pointer, end + 1);

    if (end === -1) {
      stack.push(text);
      break;
    }

    const emoji = findTag(tag);

    text = text.substring(end + 1, text.length);

    if (emoji) {
      stack.push(`<img class="emoji" src="${require(`@/assets/emoji/${emoji.file}`)}" >`);
    } else {
      stack.push(tag);
    }
  }

  return stack.join('');
};

export function findTag (tag) {
  return emojiData.find(item => item.tag === tag);
}

export default emojiData;
